export enum ArticleChannel {
  CREATE = 'article::create',
  EDIT = 'article::patch',
  DELETE = 'article::delete',
}
